import { Component } from 'preact'

import StickyButton from '../stickyButton/stickyButton'

class DoubleStickyButton extends Component {
  constructor(props) {
    super(props)

    this.extraButtonOnClick = this.extraButtonOnClick.bind(this)
  }

  extraButtonOnClick() {
    if (this.props.second.href) window.location = this.props.second.href
  }

  render(props) {
    return (
      <StickyButton
          href={ props.first.href }
          text={ props.first.text }
          shortText={ props.first.shortText }
          goal={ props.first.goal }
          type={ props.first.type }
        >
          <button className={ `extraButton is__${props.second.type}` }
            onClick={ this.extraButtonOnClick }
            data-goal={ props.second.goal }
          >
            <span className="extraButton-text device mobile">
              { props.second.shortText || props.second.text }
            </span>
            <span className="extraButton-text device desktop laptop">
              { props.second.text }
            </span>
          </button>
        </StickyButton>
    )
  }
}

export default DoubleStickyButton
